import { CreatorCollectionCard } from '@eventbrite/creator-collection-card';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import { css, cx } from 'emotion';
import React from 'react';
import { AffiliateCodes, Collection, GACodes } from '../../types';

type Props = {
    collections?: Collection[];
    columns?: number;
};

export const AFFILIATE_CODE =
    AffiliateCodes.AFF_COLLECTIONS_FEATURING_THIS_EVENT;

export const CollectionCards: React.FC<Props> = ({
    collections,
    columns = 1,
}) => {
    if (!collections || !collections.length) {
        return <></>;
    }

    return (
        <ul
            className={cx('cc-card-list', styles.list)}
            data-testid="collection-list"
        >
            {collections?.map((collection) => {
                const {
                    id,
                    name,
                    url,
                    summary,
                    imageUrl,
                    upcomingEventsCount,
                } = collection;

                return (
                    <li
                        key={id}
                        className={'eds-l-mar-vert-2 eds-l-mar-hor-2'}
                        style={{
                            width: `calc(${(100 / columns).toFixed(
                                2,
                            )}% - 16px)`,
                        }}
                        data-testid="collection-item"
                    >
                        <CreatorCollectionCard
                            name={name}
                            slug={`${url}?aff=${AFFILIATE_CODE}`}
                            summary={summary}
                            imageUrl={imageUrl}
                            numUpcomingEvents={upcomingEventsCount}
                            onClick={() =>
                                trackAnalyticsEvent({
                                    category:
                                        GACodes.GA_CATEGORY_CREATOR_COLLECTIONS_LISTING,
                                    action: 'CollectionView',
                                    label: id,
                                })
                            }
                        />
                    </li>
                );
            })}
        </ul>
    );
};

const styles = {
    list: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin: 0 auto;
        max-width: 1336;
    `,
};
